import { gql } from '@apollo/client';

export const CREATE_API_KEY = gql`
  mutation CreateApiKey($teamId: ID!, $name: String!, $expiresAt: ISO8601DateTime) {
    createApiKey(teamId: $teamId, name: $name, expiresAt: $expiresAt) {
      apiKey {
        id
        name
        keyPrefix
        status
        createdAt
        expiresAt
        requestCount
        createdByName
      }
      rawKey
    }
  }
`;

export const REVOKE_API_KEY = gql`
  mutation RevokeApiKey($apiKeyId: ID!) {
    revokeApiKey(apiKeyId: $apiKeyId) {
      id
      name
      status
      revokedAt
    }
  }
`;
